<script>
    import FieldError from '../../shared/FieldError.svelte'
    
    export let activity
     export let errors
</script>

<!--
(a) assessing the controller’s legitimate interest, (b) impact on the data subjects, (c)
provisional balance and (d) additional safeguards applied by the controller to prevent any
undue impact on the data subjects

 - https://ec.europa.eu/justice/article-29/documentation/opinion-recommendation/files/2014/wp217_en.pdf
 - https://www.securityreport.com.br/colunas-blogs/o-que-diz-a-lgpd-sobre-a-base-legal-legitimo-interesse/#.X8aEFVlKg1g
-->
<div class="field" class:error={errors["basis.variant.interest"]}>
    <label>Interesse do Controlador</label>
    <textarea rows="3" bind:value={activity.basis.variant.interest}></textarea>
    <FieldError style="label" property={errors["basis.variant.interest"]}/>
</div>

<div class="field" class:error={errors["basis.variant.necessity"]}>
    <label>Necessidade</label>
    <textarea rows="3" bind:value={activity.basis.variant.necessity}></textarea>
    <FieldError style="label" property={errors["basis.variant.necessity"]}/>
</div>

<div class="field" class:error={errors["basis.variant.impact"]}>
    <label>Impacto no Titular</label>
    <textarea rows="3" bind:value={activity.basis.variant.impact}></textarea>
    <FieldError style="label" property={errors["basis.variant.impact"]}/>
</div>

<div class="field" class:error={errors["basis.variant.safeguards"]}>
    <label>Salvaguardas</label>
    <textarea rows="3" bind:value={activity.basis.variant.safeguards}></textarea>
    <FieldError style="label" property={errors["basis.variant.safeguards"]}/>
</div>

<div class="field" class:error={errors["basis.variant.balancing"]}>
    <label>Balanceamento</label>
    <textarea rows="3" bind:value={activity.basis.variant.balancing}></textarea>
    <FieldError style="label" property={errors["basis.variant.balancing"]}/>
</div>

